/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {enums} from './enums';

export const ZipParameters = yup.object({
   type: yup.string().oneOf(enums.zipType.keys),
   style: yup.string().oneOf(enums.style.keys),
   folderPaths: yup
      .array()
      .of(yup.string())
      .transform(function (value, origin) {
         if (value && value.length) {
            return value;
         } else {
            return [''];
         }
      }),
   filenameTemplate: yup.string(),
   filepath: yup.string(),
   dateFormat: yup.string(),
   encryption: yup.string().oneOf(enums.encryption.keys),
   password: passphrase(),
   deleteZippedFile: yup.boolean(),
   overwrite: yup.string().oneOf(enums.overwrite.keys),
   continueOnFailure: yup.boolean(),
});
export type IZipParameters = yup.InferType<typeof ZipParameters>;
